import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  content: {
    textAlign: 'center',
    fontSize: '16px',
    color: theme.palette.text.primary,
  },
  button: {
    fontSize: '14px',
    padding: '0.7rem 1rem 0.5rem 1rem',
  },
  cancelButton: {
    fontSize: '14px',
    padding: '0.7rem 1rem 0.5rem 1rem',
    backgroundColor: theme.palette.common.white,
  },
  buttonGroup: {
    marginTop: '4rem',
  },
}));

export default useStyles;
